module.exports = __webpack_public_path__ + "img/logo.fce79465.png";